import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'

export const useCarUsersStore = defineStore('car-users', () => {

    const configStore   = useConfigStore()
    const requestsStore = useRequestsStore()
    const tokenStore    = useTokenStore()

    const carUsers = ref({})
    const carUsersProcess = ref(false)
    const carUsersMsg = ref({})

    const carUsersCreateList = ref({})
    const carUsersCreateListMsg = ref({})
    const carUsersCreateListProcess = ref(false)

    const carUsersCreateProcess = ref(false)
    const carUsersCreateMsg = ref({})

    const carUsersUpdateProcess = ref(false)
    const carUsersUpdateMsg = ref({})

    const carUsersDeleteProcess = ref(false)
    const carUsersDeleteMsg = ref({})

    async function createCarUsers(payload) {

        carUsersCreateProcess.value = true
        const token = tokenStore.access

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/users/links/cars`, 
                method: 'POST', 
                token,
                data: payload
            })

            if(!request.error) {
                carUsersCreateMsg.value = { success: true, text: 'CAR_USERS_CREATE_SUCCESS' }
            } else {
                carUsersCreateMsg.value = { success: false, text: request.error }
            }

        } else {
            carUsersCreateMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carUsersCreateProcess.value = false
    }

    async function readCarUsers(payload) {

        carUsersProcess.value = true
        const token = tokenStore.access

        if(token) {

            let params = ''

            if(payload.params) {

                for(let param in payload.params) {

                    params.length ?
                        params += '&' + param + '=' + payload.params[param] :
                        params = '?' + param + '=' + payload.params[param]
                }
            }

            const request = await requestsStore.fetchRequest({ 
                address: `${configStore.httpServer}/links/cars/${payload.car}/users${params}`,
                method: 'GET', 
                token
            })

            if(!request.error) {
                carUsers.value = request
                carUsersMsg.value = { success: true }
            } else {
                carUsers.value = {}
                carUsersMsg.value = { success: false, text: request.error }
            }

        } else {
            carUsersMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carUsersProcess.value = false
        return carUsers.value
    }

    async function readCarUsersCreateList(payload) {

        carUsersCreateListProcess.value = true
        const token = tokenStore.access

        if(token) {

            let params = ''

            if(payload) {
                for(let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/users${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                carUsersCreateList.value = request
                carUsersCreateListMsg.value = { success: true }
            } else {
                carUsersCreateList.value = {}
                carUsersCreateListMsg.value = { success: false, text: request.error }
            }

        } else {
            carUsersCreateListMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carUsersCreateListProcess.value = false
        return carUsersCreateList.value
    }

    async function updateCarUsers(payload) {

        carUsersUpdateProcess.value = true
        const token = tokenStore.access

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/users/links/cars`, 
                method: 'PUT', 
                token,
                data: payload
            })

            if(!request.error) {
                carUsersUpdateMsg.value = { success: true, text: 'CAR_USERS_UPDATE_SUCCESS' }
            } else {
                carUsersUpdateMsg.value = { success: false, text: request.error }
            }

        } else {
            carUsersUpdateMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carUsersUpdateProcess.value = false
    }

    async function deleteCarUsers(payload) {

        carUsersDeleteProcess.value = true
        const token = tokenStore.access

        if(token) {

            let params = ''

            if(payload) {
                for(let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/users/links/cars${params}`, 
                method: 'DELETE', 
                token
            })

            if(!request.error) {
                carUsersDeleteMsg.value = { success: true, text: 'CAR_USERS_DELETE_SUCCESS' }
            } else {
                carUsersDeleteMsg.value = { success: false, text: request.error }
            }

        } else {
            carUsersDeleteMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carUsersDeleteProcess.value = false
    }

    const setCarUsersMsg        = data => carUsersMsg.value         = data
    const setCarUsersCreateMsg  = data => carUsersCreateMsg.value   = data
    const setCarUsersUpdateMsg  = data => carUsersUpdateMsg.value   = data
    const setCarUsersDeleteMsg  = data => carUsersDeleteMsg.value   = data

    return {

        configStore,
        requestsStore,
        tokenStore,
        carUsers,
        carUsersProcess,
        carUsersMsg,
        carUsersCreateList,
        carUsersCreateListMsg,
        carUsersCreateProcess,
        carUsersCreateMsg,
        carUsersUpdateProcess,
        carUsersUpdateMsg,
        carUsersDeleteProcess,
        carUsersDeleteMsg,
        createCarUsers,
        readCarUsers,
        readCarUsersCreateList,
        updateCarUsers,
        deleteCarUsers,
        setCarUsersMsg,
        setCarUsersCreateMsg,
        setCarUsersUpdateMsg,
        setCarUsersDeleteMsg
    }
})
